interface AvatarProps {
  username: string;
  photoUrl?: string | null;
  size?: "sm" | "md" | "lg";
}

// Colors for avatar backgrounds
const AVATAR_COLORS: readonly string[] = [
  "#e94560", // accent red
  "#4ade80", // green
  "#60a5fa", // blue
  "#fbbf24", // yellow
  "#a855f7", // purple
  "#f472b6", // pink
  "#22d3ee", // cyan
  "#fb923c", // orange
] as const;

// Generate a consistent color based on username
function getColorFromUsername(username: string): string {
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index] as string;
}

function Avatar({ username, photoUrl, size = "md" }: AvatarProps) {
  const displayName = username || "?";
  const initial = displayName.charAt(0).toUpperCase();
  const backgroundColor = getColorFromUsername(displayName);

  // If we have a photo URL, show the image
  if (photoUrl) {
    return (
      <div className={`avatar avatar-${size}`}>
        <img
          src={photoUrl}
          alt={displayName}
          className="avatar-img"
          onError={(e) => {
            // Fallback to initial on error
            const target = e.target as HTMLImageElement;
            target.style.display = "none";
            target.parentElement!.style.backgroundColor = backgroundColor;
            target.parentElement!.textContent = initial;
          }}
        />
      </div>
    );
  }

  // Fallback to initial-based avatar
  return (
    <div
      className={`avatar avatar-${size}`}
      style={{ backgroundColor }}
    >
      {initial}
    </div>
  );
}

export default Avatar;
